import React from "react";
import {
    Navigate,
} from "react-router-dom";


const ClientsListComponent = React.lazy(() => import("../../../../../components/clients/components/list/page"));
const ClientsAddComponent = React.lazy(() => import("../../../../../components/clients/components/add/page"));

export const clientRoutes = [
   
    {
        path: 'add',
        element: <ClientsAddComponent />
    },
    {
        path: 'edit',
        element: <Navigate to="/administration/clients/add" />
    },
    {
        path: 'edit/:id',
        element: <ClientsAddComponent />
    },
     {
        path: 'list',
        element: <ClientsListComponent />
    },
    {
        path: '',
        element: <Navigate replace to="/administration/clients/list" />
    },
];